import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

import { useResidenceData } from './useResidenceData'

import { ContainerGroupField } from '@/components/common'
import { AutocompleteControl, SelectControl } from '@/components/form-controls'
import { DemographicFormData } from '@/types/forms/'

interface ResidenceControlProps {
    control: Control<DemographicFormData>
    watchIdCityResidence: string | undefined
    watchDepartmentResidence: string
    watchCountryResidence: string
    text: string
    onFieldChange?: (field: string, value: any) => void
}

export const ResidenceControl = ({
    control,
    watchIdCityResidence,
    watchDepartmentResidence,
    watchCountryResidence,
    text: text,
    onFieldChange
}: ResidenceControlProps): JSX.Element => {
    const { t } = useTranslation()

    const {
        countries,
        idCityResidence,
        residenceDepartments,
        optionsLocality,
        TimeResidence
    } = useResidenceData(watchCountryResidence, watchDepartmentResidence)

    return (
        <ContainerGroupField tittleGroup={t('forms.groups.residence')}>
            <AutocompleteControl
                name="countryResidence"
                control={control}
                label={t(`${text}.countryResidence`)}
                options={countries}
                rules={{
                    required: t(`${text}.required.countryResidence`)
                }}
                onChangeCustom={(value) =>
                    onFieldChange?.('countryResidence', value)
                }
            />
            <AutocompleteControl
                name="departmentResidence"
                control={control}
                label={t(`${text}.departmentResidence`)}
                options={residenceDepartments}
                placeholder={
                    !watchCountryResidence
                        ? t('forms.common.placeholders.selectCountryFirst')
                        : t(`${text}.departmentResidence`)
                }
                isDisabled={!watchCountryResidence}
                rules={{
                    required: t(`${text}.required.departmentResidence`)
                }}
                onChangeCustom={(value) =>
                    onFieldChange?.('departmentResidence', value)
                }
            />
            {watchCountryResidence === 'CO' && (
                <AutocompleteControl
                    name="idCityResidence"
                    control={control}
                    label={t(`${text}.cityResidence`)}
                    options={idCityResidence}
                    valueKey="label"
                    placeholder={
                        !watchDepartmentResidence
                            ? t('forms.common.placeholders.selectDepartmentFirst')
                            : t(`${text}.cityResidence`)
                    }
                    isDisabled={!watchDepartmentResidence}
                    rules={{
                        required: t(`${text}.required.cityResidence`)
                    }}
                    onChangeCustom={(value) =>
                        onFieldChange?.('idCityResidence', value)
                    }
                />
            )}
            {watchIdCityResidence === 'BOGOTA' &&
                watchCountryResidence === 'CO' && (
                    <SelectControl
                        name="timeResidence"
                        control={control}
                        label={t(`${text}.timeResidence`)}
                        options={TimeResidence}
                        rules={{
                            required: t(`${text}.required.timeResidence`)
                        }}
                    />
                )}
            {watchIdCityResidence === 'BOGOTA' &&
                watchCountryResidence === 'CO' && (
                    <AutocompleteControl
                        name="localidad"
                        control={control}
                        label={t(`${text}.localidad`)}
                        options={optionsLocality}
                        rules={{
                            required: t(`${text}.required.localidad`)
                        }}
                    />
                )}
        </ContainerGroupField>
    )
}
